<div *ngIf="!userConnected">
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" (click)="onClick()" style="display: inline-block">
    <circle stroke="#FFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
        cx="12" cy="7" r="4" />
    <path stroke="#FFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
        d="M6 21V19C6 16.7909 7.79086 15 10 15H14C16.2091 15 18 16.7909 18 19V21"/>
</svg>
    <span (click)="onClick()" style="color:white;display: inline-block; vertical-align: super; margin-left: 5px;cursor: pointer; text-decoration: underline; font-weight: bold">Connexion</span>
</div>
<div *ngIf="userConnected">
  <svg  width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="display: inline-block">
    <circle stroke="#013166" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            cx="9" cy="7" r="4"/>
    <path stroke="#013166" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          d="M3 21V19C3 16.7909 4.79086 15 7 15H11C13.2091 15 15 16.7909 15 19V21" />
    <path stroke="#049c0a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          d="M16 11L18 13L22 9"/>
  </svg>
  <span style="display: inline-block; vertical-align: super; margin-left: 1rem;">{{getUserDetails()}}</span>
  <a (click)="onClick()" style="display: inline-block; vertical-align: super; margin-left: 3rem; cursor: pointer; text-decoration: underline; font-weight: bold">Déconnexion</a>
</div>
